export default "__VITE_ASSET__BnL1tiS3__"